module.exports = __webpack_public_path__ + "img/marcella-sm.41c1784a.svg";